import { Box, ColorOptions, Icon, IconOptions, Spacer, Text, TextInput } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { useCallback } from 'react'
import { Routes } from '../../nav/routes'
import { formatTimer, isMobile } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { SvgImage } from '../SvgImage'
import { closerMarginIcon, rightToMarginIcon, titleCase } from './headerFunctionHelpers'
import { styles } from './styles'
interface CustomHeaderProps {
  screenName: string
  isBackButtonVisible?: boolean
  backLabelText?: string
  forceHideRightIcon?: boolean
  forceHideLeftIcon?: boolean
  handleFilterIconPress?: () => void
  onChange?: (value: string) => void
  timer?: number
  navigation: any
}

export const JioLogo = () => (
  <ModBox {...styles.leftContainer}>
    <SvgImage imageName={'Splash'} width={32} height={32} />
    <Spacer direction="horizontal" size={10} />
    <Text fontFamily="JioType-Bold" color={'BLACK_21'} fontSize={12}>
      JioPay
      <Text title={' Business'} fontFamily="JioType-Light" color={'BLACK_21'} />
    </Text>
  </ModBox>
)

const CustomHeader = ({
  screenName = Routes.TRANSACTIONS,
  isBackButtonVisible = false,
  backLabelText,
  forceHideRightIcon,
  forceHideLeftIcon,
  handleFilterIconPress,
  onChange = () => null,
  timer = 0,
  navigation,
}: CustomHeaderProps) => {
  const isSearchScreen = screenName === 'search'
  const isQrScreen = screenName === Routes.QR_CODE
  const setSearchString = useCallback((value) => onChange(value), [onChange])

  const leftContainer = () => {
    return (
      <Box {...styles.leftContainer}>
        <ModBox flexDirection="row">
          <ModBox
            underlayColor="WHITE"
            testID="arrow-back"
            onPress={() => navigation?.goBack()}
            show={isBackButtonVisible}>
            <Icon id={'ARROW_BACK' as IconOptions} color="BLUE" size={20} />
          </ModBox>
          <Spacer direction="horizontal" size={30} />
          <Text type="h2Bold">{titleCase(backLabelText ?? '')}</Text>
        </ModBox>
      </Box>
    )
  }

  const showIcon = (id: string, hideIcon: boolean | undefined) => {
    if (hideIcon) {
      return false
    } else if (id === '') {
      return false
    } else {
      return true
    }
  }

  const iconButton = (id: string, onPress: () => any | undefined | null, hideIcon: boolean | undefined) => {
    return (
      <ModBox
        underlayColor="WHITE"
        show={showIcon(id, hideIcon)}
        onPress={onPress}
        testID={'iconBtn-' + id}
        bg={defaultColors.WHITE as ColorOptions}>
        <Icon id={id as IconOptions} color="BLUE" size={22} />
      </ModBox>
    )
  }

  const isLarge = useIsLargeScreen()

  const rightContainer = (onIconPress: any) => {
    const hideLeftIcon = forceHideLeftIcon ?? false
    const hideRightIcon = forceHideRightIcon ?? false
    const preLoadFunc = closerMarginIcon(screenName, navigation, onIconPress)
    return (
      <ModBox show={!isSearchScreen} {...styles.rightContainer}>
        {iconButton(preLoadFunc.iconName, preLoadFunc.onPress, hideLeftIcon)}
        <Spacer direction="horizontal" size={30} />
        {iconButton(
          rightToMarginIcon(screenName, navigation).iconName,
          rightToMarginIcon(screenName, navigation).onPress,
          hideRightIcon,
        )}
        <ModBox show={isQrScreen && timer > 0}>
          <Text type={'h4'} color={'TEXT_ERROR'}>
            {formatTimer(timer)}
          </Text>
        </ModBox>
      </ModBox>
    )
  }

  if (isMobile(isLarge)) {
    return (
      <Box {...styles.container}>
        {leftContainer()}
        {rightContainer(handleFilterIconPress)}
        <ModBox show={isSearchScreen} width={'40%'} flexShrink={1}>
          <TextInput autoFocus={true} placeholder={'Search'} onChangeText={setSearchString} autoCorrect={false} />
        </ModBox>
      </Box>
    )
  } else {
    return null
  }
}

export { CustomHeader }
